class ReferencePool {
  static name = 'ReferencePool';

  constructor() {
    this.registrationCount = 0;
    this.data = {};
    this.onRegisterCallbackRegistrationCount = 0;
    this.onRegisterCallbackData = {};
    this.onUnregisterCallbackRegistrationCount = 0;
    this.onUnregisterCallbackData = {};
  }

  onRegister(registeredReferenceIds, registeredReferences) {
    for (let callback of Object.values(this.onRegisterCallbackData)) {
      callback(registeredReferenceIds, registeredReferences);
    }
  }

  onUnregister(unregisteredReferenceIds, unregisteredReferences) {
    for (let callback of Object.values(this.onUnregisterCallbackData)) {
      callback(unregisteredReferenceIds, unregisteredReferences);
    }
  }
}
const referencePool = new ReferencePool();

class Reference {
  static name = 'Reference';

  constructor(refClass, referFrom, referTo) {
    this.refClass = refClass;
    this.referFrom = referFrom;
    this.referTo = referTo;
  }
}

export { Reference }

export default {
  registerOnRegisterCallback(callback) {
    let callbackId = String(referencePool.onRegisterCallbackRegistrationCount);
    referencePool.onRegisterCallbackData[callbackId] = callback;
    ++referencePool.onRegisterCallbackRegistrationCount;
    return callbackId;
  },

  unregisterOnRegisterCallback(callbackId) {
    if (Object.keys(referencePool.onRegisterCallbackData).includes(callbackId)) {
      delete referencePool.onRegisterCallbackData[callbackId];
    }
  },

  registerOnUnregisterCallback(callback) {
    let callbackId = String(referencePool.onUnregisterCallbackRegistrationCount);
    referencePool.onUnregisterCallbackData[callbackId] = callback;
    ++referencePool.onUnregisterCallbackRegistrationCount;
    return callbackId;
  },

  unregisterOnUnregisterCallback(callbackId) {
    if (Object.keys(referencePool.onUnregisterCallbackData).includes(callbackId)) {
      delete referencePool.onUnregisterCallbackData[callbackId];
    }
  },

  registerReferences(...references) {
    let numNewReferences = references.length;
    let referenceIds = [];
    for (let newReferenceIdx = 0; newReferenceIdx < numNewReferences; ++newReferenceIdx) {
      let referenceId = String(referencePool.registrationCount);
      referenceIds.push(referenceId);
      referencePool.data[referenceId] = references[newReferenceIdx];
      ++referencePool.registrationCount;
    }
    referencePool.onRegister(referenceIds, references);
    return referenceIds;
  },

  unregisterReferences(...referenceIds) {
    let references = referenceIds.map(referenceId => referencePool.data[referenceId])
    for (let referenceId of referenceIds) {
      delete referencePool.data[referenceId];
    }
    referencePool.onUnregister(referenceIds, references);
  },

  getReference(referenceId) {
    return referencePool.data[referenceId];
  },

  getAllReferences() {
    return referencePool.data;
  },
}